import React from 'react'
import { Link} from "react-router-dom";
import Loading from './images/loading40.gif'

export default function ActivityLog(props) {
    return (
        <React.Fragment>
            <div class="main_wrap">
	{/* <!-- agent path --> */}
<div class="agent_path">
    <ul id="agentPath" class="agent_path-L">
        
  
        
        <li id="path5" class="last_li">
        <a href="/agents">
                <span class="lv_1">
                  ss
                </span>
                <strong>{props.user}</strong>
            </a>
        </li>
        
        <li id="path4" class="" style={{display:'none'}}>
            <a href="javascript: void(0);">
                <span class="lv_2">
                    SUP
                </span>
                <strong></strong>
            </a>
        </li>
        
        <li id="path3" class="" style={{display:'none'}}>
            <a href="javascript: void(0);">
                <span class="lv_3">
                    MA
                </span>
                <strong></strong>
            </a>
        </li>
        
        <li id="path0" class="" style={{display:'none'}}>
            <a href="javascript: void(0);">
                <span class="lv_4">
                    PL
                </span>
                <strong></strong>
            </a>
        </li>
        
        <ul class="account_pop" id="accountPop">
            <li id="popTmp" style={{display:'none'}}>
                <a href=""></a>
            </li>
        </ul>
    </ul>
</div>
	{/* <!-- Agent Left Column --> */}
<div class="col-left">

    {/* <!-- Sub Menu and Path --> */}
    <div class="sub_path">
        {/* <!-- Sub Menu --> */}
        <ul class="menu-list">
        <li class="class">Position</li>
            <li><Link to="/myAccount/accountCashStatement" id="accountStatement" >Account Statement</Link></li>
            <li><Link to="/myAccount/accountSummary" id="accountSummary" >Account Summary</Link></li>
            {/* <li><Link to="/myAccount/transferredLog" id="transferredLog" >Transferred Log</Link></li> */}
            <li class="class">Account Details</li>
            <li><Link to="/myAccount/profile" id="profile" >Profile</Link></li>
            <li><Link to="/myAccount/activityLog" id="activityLog" class="select">Activity Log</Link></li>
        </ul>
    </div>
</div>
	{/* <!-- Center Column --> */}
{/* <!-- Center Column --> */}
<div id="report" class="col-center report">
{/* <!-- Loading Wrap --> */}
<div id="loading" class="loading-wrap" style={{display:'none'}}>
  <ul class="loading">
    <li><img src={Loading}/></li>
    <li>Loading...</li>
  </ul>
</div>

{/* <!-- Message --> */}
<div id="message" class="message-wrap success">
  <a class="btn-close">Close</a>
  <p></p>
</div>
	<h2>Activity Log
	</h2>
	<table style={{display:'none'}}>
		<tbody><tr id="tempTr">
			<td class="align-L" id="loginDate"></td>
			<td class="align-L" id="loginMessage"><span class=""></span></td>
			<td id="ipAddress"></td>
			<td id="isp"></td>
			<td id="location"></td>
		</tr>
	</tbody></table>

	{/* <!-- Report Table --> */}
    <table className="table01">
    <tbody>
        <tr>
            <th width="15%" className="align-L">Login Date &amp; Time
            </th>
            <th width="15%" className="align-L">Login Status
            </th>
            <th width="12%">IP Address
            </th>
            <th width="28%">ISP
            </th>
            <th width>City/State/Country
            </th>
            <th width>User Agent Type
            </th>
        </tr>
    </tbody>
    <tbody id="content">
     
        <tr id="tempTr">
            <td className="align-L" id="loginDate">2021-12-06 23:01:05</td>
            <td className="align-L " id="loginMessage">Login Success</td>
            <td id="ipAddress">-</td>
            <td id="isp">-</td>
            <td id="location">-</td>
            <td id="userAgentType">-</td>
        </tr>
    </tbody>
</table>
	{/* <!-- Pages List --> */}

<div>
	<ul id="pageNumberContent" className="pages">
    <li id="prev"><a href="javascript:void(0);" className="disable" style={{pointerEvents: 'none'}}>Prev</a></li>
    <li id="pageNumber"><a href="javascript:void(0);" className="select" style={{pointerEvents: 'none'}}>1</a></li>
    <li id="next"><a href="javascript:void(0);" className="disable" style={{pointerEvents: 'none'}}>Next</a></li>
</ul>

	{/* <ul id="pageNumberContent" class="pages"><li id="prev"><a href="javascript:void(0);" class="disable" style={{pointerEvents:' none'}}>Prev</a></li><li id="pageNumber"><a href="javascript:void(0);" class="select" style={{pointerEvents:' none'}}>1</a></li><li id="pageNumber"><a href="javascript:void(0);">2</a></li><li id="next"><a href="javascript:void(0);">Next</a></li></ul> */}
</div>

</div>
</div>
        </React.Fragment>
    )
}
